import { Component, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';

import { LastGuaranteeRequestsWidgetComponent } from './last-guarantee-requests-widget.component';
import { QualityFeedbackCardComponent } from './quality-feedback/quality-feedback-card.component';

@Component({
	selector: 'copo-claim-dashboard',
	templateUrl: './claim-dashboard.component.html',
	styleUrl: './claim-dashboard.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		BackButtonComponent,
		TranslateModule,
		NgIf,
		QualityFeedbackCardComponent,
		LastGuaranteeRequestsWidgetComponent
	]
})
export class ClaimDashboardComponent {
	readonly user: User;

	constructor(
		private readonly userService: UserService
	) {
		this.user = this.userService.user;
	}

	hasIssueService() {
		return this.user.hasService('QUAPP');
	}

	hasRaiseIssueService() {
		return this.user.hasService('QUAPP') && (this.user.isClaimDetector() || this.user.isClaimValidator());
	}

	hasGuaranteeService() {
		return this.user.hasService('PGNTE');
	}

	hasAnyService() {
		return this.hasRaiseIssueService() || this.hasGuaranteeService();
	}
}
